import { render } from "./EditPostView.vue?vue&type=template&id=377767de&scoped=true"
import script from "./EditPostView.vue?vue&type=script&lang=js"
export * from "./EditPostView.vue?vue&type=script&lang=js"

import "./EditPostView.vue?vue&type=style&index=0&id=377767de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377767de"]])

export default __exports__